const { html } = window;

export default ({ members, text}) => `
<div class="Members-inputWrapper">
    <datalist id="libraries" class="js-datalist" tabindex="-1">
    ${members && members.map((library) => `<option value="${library.attributes.branchName}">`).join('')}
    
    </datalist>

    <input type="text" list="libraries" placeholder="${html('members.libraryInputPlaceholder')}" 
        class="Members-selectAutoComplete js-select-library-autocomplete is-blur" aria-label="${html('members.libraryInputPlaceholder')}">

    <div role="button" class="Members-clearSearch js-clear-input icon-clear" tabindex="0" title="${html('clearSearch')}"></div>

    <div class="Members-noMatchesFound js-no-matches-found">${text('members.noLibrariesFound')}</div>
</div>
`;
